import { Grid } from "@mui/material";
import { McParameterDetailResponseDto } from "src/api/references/referenceServicesDtos";
import ByzCard from "src/components/core-components/ByzCard";
import { ByzMuiDateTimePicker } from "src/components/core-components/mui/inputs/ByzMuiDateTimePicker";
import ByzMuiTextField from "src/components/core-components/mui/inputs/ByzMuiTextField";
import ByzMuiTypography from "src/components/core-components/mui/inputs/ByzMuiTypography";
import ByzMcParameterDetailSelect from "src/components/shared-components/ByzMcParameterDetailSelect";

interface PainCardProps {
  t: (key: string) => string;
  cardData: any;
  selectedMCPs: Record<string, any>;
  handleMCPChange: (key: string, value: McParameterDetailResponseDto) => void;
  handleChange: (key: string, value: any) => void;
  getMCPParameterDetails: (id: number) => any;
  mcpCacheLoaded: boolean;
  typedFormData: Record<string, any>;
}

const PainLocationCard: React.FC<PainCardProps> = ({
  t,
  cardData,
  selectedMCPs,
  handleChange,
  handleMCPChange,
  getMCPParameterDetails,
  mcpCacheLoaded,
  typedFormData,
}) => {
  return (
    <ByzCard sx={{ mt: 2, p: 2 }}>
      {/* SIDE */}
      <Grid container spacing={2} alignItems="center" mt={1}>
        <Grid item xs={4}>
          <ByzMuiTypography>
            {t("pain-assessment-scale.pain-assessment.center.side")}
          </ByzMuiTypography>
        </Grid>
        <Grid item xs={8}>
          <ByzMcParameterDetailSelect
            title={t("select")}
            mcpId={cardData.mcpConfig.SIDE.mcpId}
            multiple={false}
            handleChange={(val) => {
              if (val && !Array.isArray(val)) {
                handleMCPChange("SIDE", val as McParameterDetailResponseDto);
              }
            }}
            value={selectedMCPs.SIDE}
            sx={{ width: "100%" }}
            cachedData={getMCPParameterDetails(cardData.mcpConfig.SIDE.mcpId)}
            cacheLoaded={mcpCacheLoaded}
          />
        </Grid>
      </Grid>
      {/* TIME */}
      <Grid container spacing={2} alignItems="center" mt={1}>
        <Grid item xs={4}>
          <ByzMuiTypography>
            {t("pain-assessment-scale.pain-assessment.center.duration")}
          </ByzMuiTypography>
        </Grid>
        <Grid item xs={8}>
          <ByzMuiDateTimePicker
            sx={{ width: "100%" }}
            value={selectedMCPs.DURATION}
            onChange={(val) => {
              if (val) {
                handleMCPChange("DURATION", val);
              }
            }}
          />
        </Grid>
      </Grid>
      {/* INCREASING_FACTORS */}
      <Grid container spacing={2} alignItems="center" mt={1}>
        <Grid item xs={4}>
          <ByzMuiTypography>
            {t(
              "pain-assessment-scale.pain-assessment.center.increasing-factors"
            )}
          </ByzMuiTypography>
        </Grid>
        <Grid item xs={8}>
          <ByzMcParameterDetailSelect
            title={t("select")}
            mcpId={cardData.mcpConfig.INCREASING_FACTORS.mcpId}
            multiple={false}
            handleChange={(val) => {
              if (val && !Array.isArray(val)) {
                handleMCPChange(
                  "INCREASING_FACTORS",
                  val as McParameterDetailResponseDto
                );
              }
            }}
            value={selectedMCPs.INCREASING_FACTORS}
            sx={{ width: "100%" }}
            cachedData={getMCPParameterDetails(
              cardData.mcpConfig.INCREASING_FACTORS.mcpId
            )}
            cacheLoaded={mcpCacheLoaded}
          />
        </Grid>
      </Grid>
      {/* INCREASING_FACTORS_EXPLANATION */}
      <Grid container spacing={2} alignItems="center" mt={1}>
        <Grid item xs={4}>
          <ByzMuiTypography>
            {t("pain-assessment-scale.explanation")}
          </ByzMuiTypography>
        </Grid>
        <Grid item xs={8}>
          <ByzMuiTextField
            fullWidth
            value={typedFormData.INCREASING_FACTORS_EXPLANATION || ""}
            onChange={(e) =>
              handleChange("INCREASING_FACTORS_EXPLANATION", e.target.value)
            }
          />
        </Grid>
      </Grid>
      {/* REDUCING_FACTORS */}
      <Grid container spacing={2} alignItems="center" mt={1}>
        <Grid item xs={4}>
          <ByzMuiTypography>
            {t(
              "pain-assessment-scale.pain-assessment.center.reducing-factors"
            )}
          </ByzMuiTypography>
        </Grid>
        <Grid item xs={8}>
          <ByzMcParameterDetailSelect
            title={t("select")}
            mcpId={cardData.mcpConfig.REDUCING_FACTORS.mcpId}
            multiple={false}
            handleChange={(val) => {
              if (val && !Array.isArray(val)) {
                handleMCPChange(
                  "REDUCING_FACTORS",
                  val as McParameterDetailResponseDto
                );
              }
            }}
            value={selectedMCPs.REDUCING_FACTORS}
            sx={{ width: "100%" }}
            cachedData={getMCPParameterDetails(
              cardData.mcpConfig.REDUCING_FACTORS.mcpId
            )}
            cacheLoaded={mcpCacheLoaded}
          />
        </Grid>
      </Grid>
      {/* EVALUATION_REASON */}
      <Grid container spacing={2} alignItems="center" mt={1}>
        <Grid item xs={4}>
          <ByzMuiTypography>
            {t(
              "pain-assessment-scale.pain-assessment.center.evolution-reason"
            )}
          </ByzMuiTypography>
        </Grid>
        <Grid item xs={8}>
          <ByzMcParameterDetailSelect
            title={t("select")}
            mcpId={cardData.mcpConfig.EVALUATION_REASON.mcpId}
            multiple={false}
            handleChange={(val) => {
              if (val && !Array.isArray(val)) {
                handleMCPChange(
                  "EVALUATION_REASON",
                  val as McParameterDetailResponseDto
                );
              }
            }}
            value={selectedMCPs.EVALUATION_REASON}
            sx={{ width: "100%" }}
            cachedData={getMCPParameterDetails(
              cardData.mcpConfig.EVALUATION_REASON.mcpId
            )}
            cacheLoaded={mcpCacheLoaded}
          />
        </Grid>
      </Grid>
      {/* REDUCING_FACTORS_EXPLANATION */}
      <Grid container spacing={2} alignItems="center" mt={1}>
        <Grid item xs={4}>
          <ByzMuiTypography>
            {t("pain-assessment-scale.explanation")}
          </ByzMuiTypography>
        </Grid>
        <Grid item xs={8}>
          <ByzMuiTextField
            fullWidth
            value={typedFormData.REDUCING_FACTORS_EXPLANATION || ""}
            onChange={(e) =>
              handleChange("REDUCING_FACTORS_EXPLANATION", e.target.value)
            }
          />
        </Grid>
      </Grid>
    </ByzCard>
  );
};

export default PainLocationCard;
